<app-modal-option-panel>
  <div class="register" data-testid="verify-pending-container">
    <div class="input-el flex-column">
      <div class="succ-icon">
        <img
          [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/registration_icon_email.svg'" />
      </div>
      <h3>{{ languageService.languageJSON.AccountDialog_Verification }}</h3>
      <h5 class="h5-verify">
        {{ languageService.languageJSON.AccountDialog_Verification_Description }}
      </h5>
      @if (!emailSent) {
        <h5 class="h5-link" (click)="resendEmail.emit()" data-testid="verify-pending-resend-link">
          {{ languageService.languageJSON.AccountDialog_ResendEmail }}
        </h5>
      }
      @if (emailSent) {
        <h5 class="h5-link inactive">{{ languageService.languageJSON.AccountDialog_EmailSent }}</h5>
      }
    </div>
  </div>
</app-modal-option-panel>
